angular.module('messageCenterSocketModule', ['noticeWindowModule']).run([
    '$rootScope',
    '$timeout',
    '$compile',
    '$templateRequest',
    'modalDialog',
    '$q',
    'trsHttpService',
    '$state',
    '$controller',
    function ($rootScope, $timeout, $compile, $templateRequest, modalDialog, $q, trsHttpService, $state, $controller) {
        let socket,
            userInfo,
            heartTime = 50 * 1000,
            reconnectTime = 60000,
            reconnectTimer,
            heartTimer; // 心跳时间
        initStatus();
        initData();

        /**
         * [createWindow description] 创建一个小窗口
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        function createWindow(data) {
            if (!angular.isObject(data)) {
                return;
            }
            getWindowTemplate(data.remindType).then((template) => {
                compileTemplate(template, data);
            });

            /**
             * [getWindowTemplate description]获取弹窗模板
             *
             * @param  {[type]}  type   [type description] 提醒类型，notice代表通知公共，draft代表稿件（目前只有送审指定审核人）
             *
             * @return  {[type]}   [return description]
             */
            function getWindowTemplate(type) {
                let deffer = $q.defer();
                let tpl = './MC/socket/noticeWindow/noticeWindow_tpl.html';
                var templateObj = {
                    notice: './MC/socket/noticeWindow/noticeWindow_tpl.html',
                    draft: './MC/socket/noticeWindow/draftRemind_tpl.html'
                };
                if (type) {
                    tpl = templateObj[type];
                }
                $templateRequest(tpl).then((template) => {
                    deffer.resolve(template);
                });
                return deffer.promise;
            }

            /**
             * [compileTemplate description] 编译模板
             * @param  {[type]} template [description] 模板字符串
             * @param  {[object]} noticeInfo [description] 提醒内容
             * @return {[type]}          [description]
             */
            function compileTemplate(template, noticeInfo) {
                noticeInfo = angular.isObject(noticeInfo) ? noticeInfo : {};
                let $template = $(template);
                var controller = {};
                controller.$scope = $rootScope.$new();
                controller.$element = $template;
                controller.noticeInfo = noticeInfo;
                noticeInfo.close = function () {
                    controller.$element.remove();
                    controller.$scope.$destroy();
                };
                $template = $compile($template)(controller.$scope);
                $('body').append($template);
                $timeout(() => {
                    let number = Math.floor((window.innerHeight - 85) / 180);
                    $rootScope.$broadcast('newWindow', {
                        number: number,
                    });
                    $controller('noticeWindowCtrl', controller);
                });
            }
        }

        /**
         * [connectMessageCenter description] 连接消息中心
         * @return {[type]} [description]
         */
        function connectMessageCenter() {
            if (angular.isUndefined(window.WebSocket)) {
                modalDialog.alertType('连接消息中心失败，因为您的浏览器不支持WebSocket', '', 'warning', false);
                return;
            }
            let host = window.location.host;
            let protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
            socket = new WebSocket(`${protocol}://${host}/websocket/${userInfo.ID}`);
            // socket = new WebSocket(`ws://sly.trscd.com.cn/websocket/${userInfo.ID}`); // 测试用临时
            // 打开事件
            socket.onopen = function (msg) {
                checkHeart();
                // socket.send("这是来自客户端的消息" + location.href + new Date());
            };
            // 获得消息事件
            socket.onmessage = function (msg) {
                try {
                    msg = JSON.parse(msg.data || msg);
                    // 后端要求暂时只展示公告消息
                    if (msg.opertype === 1){ // 表示待审稿件提醒（指定审核人）
                        msg.remindType = msg.messageType || 'draft';
                        createWindow(msg);
                    }
                    if (msg.messageType === 'notice' || msg.opertype === 124) { // 124表示稿件签发失败
                        createWindow(msg);
                    }
                } catch (e) {
                    // 
                } finally {
                    checkHeart();
                }
                // console.log(msg.data);
                // 发现消息进入    开始处理前端触发逻辑
            };
            // 关闭事件
            socket.onclose = function (e) {
                // console.log(e);
                // console.log(`Socket已断开，正在尝试${reconnectTime / 1000}秒钟后重新连接`);
                reconnect();
            };
            // 发生了错误事件
            socket.onerror = function (e) {
                // console.log(`连接消息中心失败，未知原因,正在尝试${reconnectTime / 1000}秒钟后重新连接`);
                // modalDialog.alertType('连接消息中心失败，未知原因', "", "warning", false, () => {
                reconnect();
                // });
                // 此时可以尝试刷新页面
            };
        }

        /**
         * [reconnect description] 断开重连接
         * @return {[type]} [description]
         */
        function reconnect() {
            if (reconnectTimer) {
                clearTimeout(reconnectTimer);
                reconnectTimer = null;
            }
            if (socket) {
                socket.close();
                socket = null;
            }
            reconnectTimer = setTimeout(connectMessageCenter, reconnectTime);
        }

        /**
         * [getUserInfo description] 获取用户信息
         * @return {[type]} [description]
         */
        function getUserInfo() {
            let deffer = $q.defer();
            let params = {
                methodname: 'getCurrUserInfo',
                serviceid: 'mlf_extuser',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                userInfo = resp;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            // sendMessageNoStop();
            getUserInfo().then(() => {
                connectMessageCenter(checkHeart);
            });
        }

        /**
         * [checkHeart description] 检查心跳
         * @return {[type]} [description]
         */
        function checkHeart() {
            if (heartTimer) {
                clearTimeout(heartTimer);
                heartTimer = null;
            }
            heartTimer = setTimeout(() => {
                socket.send('心跳检查');
            }, heartTime);
        }

        /**
         * [sendMessageNoStop description] 不停发消息
         * @return {[type]} [description]
         */
        function sendMessageNoStop() {
            createWindow();
            setTimeout(sendMessageNoStop, 3000);
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() { }
    },
]);
